<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="1150px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="诉求人" prop="btitle">
              <el-input
                v-model="formData.Name"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="联系电话" prop="Tel">
              <el-input
                v-model="formData.Tel"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="诉求类型" prop="HandlInstruction">
              <el-input
                v-model="Type"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="诉求内容" prop="Content">
              <el-input
                disabled
                v-model="formData.Content"
                placeholder="请输入备注"
                type="textarea"
                rows="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="附件图片" prop="Content">
              <el-image
                v-if="formData.Imgurls"
                :src="formData.Imgurls"
                style="width: 170px; height: 100px"
              ></el-image>
              <span v-else>未上传</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="处理结果" prop="Result">
              <el-input
                v-model="formData.Result"
                placeholder="请输入备注"
                type="textarea"
                rows="5"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDemandDetail,
  updateDemandDetail,
} from "@/api/appealManage/appealManage";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  components: { Editor, Toolbar },
  props: {
    Type: String,
  },
  data() {
    return {
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        Result: [
          { required: true, message: "请输入处理结果", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    getUrlList() {
      return function (urls) {
        if (!urls) return [];
        return urls.split(",");
      };
    },
  },
  methods: {
    gotoPreview() {
      let routeUrl = this.$router.resolve({
        path: "/preview",
        // query: { url: this.formData.FromData },
        query: { url: this.formData.FromData },
      });
      window.open(routeUrl.href, "_blank");
    },
    openDialog(e, key) {
      this.formData = {};
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
        preview: "预览",
      };
      this.title = dic[key];
      key == "preview" && this.HttpGetIntegraltalentDetails({ id: e.Id });

      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      // const isLt4M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
      }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return isImage && isLt4M;
      return isImage;
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = {
        ...this.formData,
      };
      param.State = 1;
      this.HttpUpdateBlogDetail(param);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpGetIntegraltalentDetails(param) {
      this.isLoading = true;
      const response = await getDemandDetail(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        this.formData = raw;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await updateDemandDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await AddBlogDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.idcard {
  width: 258px;
  height: 162px;
  border: 1px solid #e4e7ed;
  background: #f4f5f7;
  border-radius: 4px;
}
</style>
